const TRIAL_URL_PATH = "/free-trial";
const TRIAL_SESSION_KEY = "isTrailEnabled";

export { TRIAL_URL_PATH, TRIAL_SESSION_KEY }

